module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACdSURBVHgB7dTdDcIgFIbhD+IAugAwgiM4ghs4gxOoE+gGZTMJC5QJwEPSJjXxxuacm+Y8SVPCzRt+AqDUP0IIR+fc2P+QMkfoi5CikbWRF6RQ5DRF7mBmFpFLrTXSMFprH+BRUkrlK+S9H1tre/AqOedDH+zmGWPMlUIDmFf0c5a279xXRmd0g7R+66bYE9IWsQHSNMYZe/eXA2qzPg3vPsP/vHNCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/medical_back_icon.png
// module id = Wy9p
// module chunks = 1